var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOrtali(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image-Ortali") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-830.000000, -2345.000000)",
    fill: "#464646",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_focus_2221564",
    transform: "translate(830.000000, 2345.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.22222222 18.8888889 1.11111111 18.8888889 1.11111111 13.7777778 0 13.7777778 0 20 6.22222222 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20 13.7777778 18.8888889 13.7777778 18.8888889 18.8888889 13.7777778 18.8888889 13.7777778 20 20 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20 0 13.7777778 0 13.7777778 1.11111111 18.8888889 1.11111111 18.8888889 6.22222222 20 6.22222222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1.11111111 1.11111111 6.22222222 1.11111111 6.22222222 0 0 0 0 6.22222222 1.11111111 6.22222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5555556,17.7115889 L10.5555556,15.6607933 C13.2558918,15.3919016 15.3918828,13.2558939 15.6607533,10.5555556 L17.7115889,10.5555556 L17.7115889,9.44444444 L15.6607667,9.44444444 C15.3919568,6.74408179 13.2559196,4.60805572 10.5555556,4.33926 L10.5555556,2.28841111 L9.44444444,2.28841111 L9.44444444,4.33927333 C6.74412664,4.60815613 4.60813729,6.74412874 4.33923333,9.44444444 L2.28841111,9.44444444 L2.28841111,10.5555556 L4.33924667,10.5555556 C4.60819971,13.2558525 6.74414892,15.3918129 9.44444444,15.66078 L9.44444444,17.7115889 L10.5555556,17.7115889 Z M5.46002889,10.5555556 L7.44627778,10.5555556 L7.44627778,9.44444444 L5.46002889,9.44444444 C5.71792681,7.36005507 7.36005248,5.71794588 9.44444444,5.46002889 L9.44444444,7.44629111 L10.5555556,7.44629111 L10.5555556,5.46002889 C12.640004,5.71782566 14.2821807,7.35999683 14.5399844,9.44444444 L12.5537111,9.44444444 L12.5537111,10.5555556 L14.5399844,10.5555556 C14.2821049,12.6399765 12.6399731,14.2821304 10.5555556,14.5400111 L10.5555556,12.5537111 L9.44444444,12.5537111 L9.44444444,14.5400111 C7.36008305,14.2820109 5.7180018,12.6399187 5.46002889,10.5555556 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOrtali);
export default __webpack_public_path__ + "static/media/Image-Ortali.81602e4cc404e392f906d6b72694667b.svg";
export { ForwardRef as ReactComponent };